/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Studio_MetaInputs */

const en_mk_studio_meta = /** @type {(inputs: Mk_Studio_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimates · proposals · client portal · handover`)
};

const id_mk_studio_meta = /** @type {(inputs: Mk_Studio_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimasi · proposal · portal klien · serah terima`)
};

/**
* | output |
* | --- |
* | "Estimates · proposals · client portal · handover" |
*
* @param {Mk_Studio_MetaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_studio_meta = /** @type {((inputs?: Mk_Studio_MetaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Studio_MetaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_studio_meta(inputs)
	return en_mk_studio_meta(inputs)
});